import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import {ref, reactive} from 'vue'
import lodash from 'lodash'
export const useLetterStore = defineStore('LetterStore', {
    state: () => {
        const slug = ref();
        return {
            PERSONAL_INFORMATION_LETTER: 'personal-information-letter',
            INQUIRY_REMOVAL_LETTER_1: 'inquiry-removal-letter-1',
            INQUIRY_REMOVAL_LETTER_2: 'inquiry-dispute-letter-round-2',
            INQUIRY_REMOVAL_LETTER_3: 'creditors-inquiry-dispute-letter-1',
            INQUIRY_REMOVAL_LETTER_4: 'creditors-inquiry-dispute-letter-2',
            CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_1: 'credit-bureaus-collection-charge-off-verification-letter-1',
            CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_2: 'credit-bureaus-collection-charge-off-verification-letter-2',
            CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_3: 'credit-bureaus-collection-charge-off-verification-letter-3',
            CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_4: 'credit-bureaus-collection-charge-off-verification-letter-4',
            CREDIT_BUREAUS_CHARGE_OFF_LETTER_1: 'credit-bureaus-charge-off-letter-1',
            CREDIT_BUREAUS_CHARGE_OFF_LETTER_2: 'credit-bureaus-charge-off-letter-2',
            CREDIT_BUREAUS_CHARGE_OFF_LETTER_3: 'credit-bureaus-charge-off-letter-3',
            CREDIT_BUREAUS_STUDENT_LOAN_LETTER_1: 'credit-bureaus-student-loan-letter-1',
            CREDIT_BUREAUS_REPOSSESSION_LETTER_1: 'credit-bureaus-repossession-letter-1',
            CREDIT_BUREAUS_REPOSSESSION_LETTER_3: 'credit-bureaus-repossession-letter-3',
            STUDENT_LOAN_LETTER_2: 'student-loan-letter-2',
            STUDENT_LOAN_LETTER_3: 'student-loan-letter-3',
            CREDIT_BUREAUS_STUDENT_LOAN_LETTER_4: 'credit-bureaus-student-loan-letter-4',
            CREDIT_BUREAU_LATE_PAYMENT_LETTER_1: 'credit-bureau-late-payment-letter-1',
            CREDIT_BUREAU_LATE_PAYMENT_LETTER_2: 'credit-bureau-late-payment-letter-2',
            CREDIT_BUREAU_LATE_PAYMENT_LETTER_3: 'credit-bureau-late-payment-letter-3',
            CREDIT_BUREAU_LATE_PAYMENT_LETTER_4: 'credit-bureau-late-payment-letter-4',
            LEXISNEXIS_CREDIT_FREEZE_REQUEST: 'lexisnexis-credit-freeze-request',
            COURT_INFORMATION_RELEASE_POLICY: 'court-information-release-policy',
            BANKRUPTCY_DISPUTE_LETTER_1: 'bankruptcy-dispute-letter-1',
            BANKRUPTCY_DISPUTE_LETTER_2: 'bankruptcy-dispute-letter-2',
            CREDITOR_COLLECTION_CHARGE_OFF_VALIDATION_LETTER_1: 'creditor-collection-charge-off-validation-letter-1',
            CREDITOR_COLLECTION_CHARGE_OFF_VALIDATION_LETTER_2: 'creditor-collection-charge-off-validation-letter-2',
            CREDITOR_COLLECTION_CHARGE_OFF_VALIDATION_LETTER_3: 'creditor-collection-charge-off-validation-letter-3',
            CREDITOR_CHARGE_OFF_LETTER_1: 'creditor-charge-off-letter-1',
            CREDITOR_LATE_PAYMENT_1: 'creditor-late-payment-1',
            CREDITOR_LATE_PAYMENT_2: 'creditor-late-payment-2',
            CREDITOR_REPOSSESSION_LETTER_1: 'creditor-repossession-letter-1',
            CREDITOR_REPOSSESSION_LETTER_2: 'creditor-repossession-letter-2',
            CREDITOR_REPOSSESSION_LETTER_3: 'creditor-repossession-letter-3',
            CREDITOR_REPOSSESSION_LETTER_4: 'creditor-repossession-letter-4',
            CREDITOR_ATTORNEY_GENERAL_LETTER_1: 'creditor-attorney-general-letter-1',
            SECURITY_FREEZE_ATTACK : 'security-freeze-attack',
            REQUEST_FOR_DISCLOSURE_ATTACK: 'request-for-disclosure-attack',
            REQUEST_AN_INVESTIGATION_ATTACK: 'request-an-investigation-attack',
            OPT_OUT_PRE_SCREEN_ATTACK: 'opt-out-pre-screen-attack',
            REQUEST_FOR_VERIFICATION_ROUND_1:'request-for-verification-round-1',
            REQUEST_FOR_VERIFICATION_ROUND_2:'request-for-verification-round-2',
            REQUEST_FOR_VERIFICATION_ROUND_3:'request-for-verification-round-3',
            CHILD_SUPPORT_LETTER_1: 'child-support-letter-1',
            CHILD_SUPPORT_LETTER_2: 'child-support-letter-2',
            DEMAND_FOR_REMOVAL_LETTER:'demand-for-removal-letter',
            REINSERTION_DISPUTE_LETTER:'reinsertion-dispute-letter',
            REQUEST_TO_REMOVE_FRAUD_ALERT:'request-to-remove-fraud-alert',
            METHOD_TO_VERIFICATION_LETTER:'method-to-verification-letter',
            // NOTIFICATION_OF_LAWSUIT_LETTER:'notification-of-lawsuit-letter',
            FAILURE_TO_RESPOND_WITHIN_15_DAYS:'failure-to-respond-within-15-days',
            FAILURE_TO_RESPOND_WITHIN_30_DAYS:'failure-to-respond-within-30-days',
            FAILED_TO_MARK_NOTICE_OF_DISPUTE:'failed-to-mark-notice-of-dispute',
            STALL_LETTER_RESPONSE:'stall-letter-response',
            CEASE_DESIST_LETTER : 41,
            AFFIDAVIT_OF_TRUTH_LETTER : 56,
            DEBT_VALIDATION_LETTER : 42,
            CREDITORS_INQUIRY_METRO_2_LETTER_1: 'attack-8', // type Attack
            CREDITORS_LATE_PAYMENT_METRO_2_LETTER_1: 'attack-9', // type Attack
            CREDITORS_COLLECTION_CHARGE_OFF_METRO_2_LETTER_1: 'attack-10', // type Attack
            REQUESTING_THE_REMOVAL_OF_INACCURATE_INFORMATION:'inaccurate-account-removal-letter-1',
            REQUESTING_THE_REMOVAL_OF_INACCURATE_ACCOUNTS_ROUND2:'inaccurate-account-removal-letter-2',
            REQUESTING_THE_REMOVAL_OF_INACCURATE_ACCOUNTS_ROUND3:'inaccurate-account-removal-letter-3',
            INTENT_TO_FILE_SUIT_VIOLATION_OF_THE_FCRA:'intent-to-file-lawsuit-fcra',
            COLLECTION_DISPUTE_LETTER_1_A:'collection-dispute-letter-1-A',
            COLLECTION_DISPUTE_LETTER_1_B:'collection-dispute-letter-1-B',
            COLLECTION_DISPUTE_LETTER_2:'collection-dispute-letter-2',
            COLLECTION_DISPUTE_LETTER_3:'collection-dispute-letter-3',
            COLLECTION_DISPUTE_LETTER_4:'collection-dispute-letter-4',
            LATE_PAYMENT_DISPUTE_LETTER_1:'late-payment-dispute-letter-1',
            LATE_PAYMENT_DISPUTE_LETTER_2:'late-payment-dispute-letter-2',
            LATE_PAYMENT_DISPUTE_LETTER_3:'late-payment-dispute-letter-3',
            LATE_PAYMENT_DISPUTE_LETTER_4:'late-payment-dispute-letter-4',
            REPOSSESSION_LETTER_1:'repossession-letter-1',
            INQUIRY_DISPUTE_LETTER_ROUND_3:'inquiry-dispute-letter-round-3',
            letters: null,
            route: useRoute(),
            router: useRouter(),
            toEditLetterData: reactive({}),
            slug,
            letterData:reactive({}),
            LETTER: 1,
            ATTACK: 2,
            RECIPIENT: {
                BUREAU: 0,
                FURNISHER: 1,
                CREDITOR: 2,
            },
            lodash,
        }
    },
    persist: {
        paths: ['letters'],
        debug: false
    },
    actions: {
        async fetchLetters() {
            const route = this.router.resolve(
                {
                    name: 'fetch-letters'
                }
            );
            try {
                this.letters = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data.letters;
                });
            } catch (error) {
                console.log(error);
            }
        },
        isStudentLoan() {
            return this.lodash.includes(
                [
                    this.CREDIT_BUREAUS_STUDENT_LOAN_LETTER_1,
                    this.STUDENT_LOAN_LETTER_2,
                    this.STUDENT_LOAN_LETTER_3,
                    this.CREDIT_BUREAUS_STUDENT_LOAN_LETTER_4,
                ],
                this.route.params.letter
            );
        },
        isChildSupport() {
            return this.lodash.includes(
                [
                    this.CHILD_SUPPORT_LETTER_1,
                    this.CHILD_SUPPORT_LETTER_2,
                ],
                this.route.params.letter
            );
        },
        isRepossession() {
            return this.lodash.includes(
                [
                    this.CREDIT_BUREAUS_REPOSSESSION_LETTER_1,
                    this.CREDIT_BUREAUS_REPOSSESSION_LETTER_3,
                    this.CREDITOR_REPOSSESSION_LETTER_1,
                    this.CREDITOR_REPOSSESSION_LETTER_2,
                    this.CREDITOR_REPOSSESSION_LETTER_3,
                    this.CREDITOR_REPOSSESSION_LETTER_4,
                ],
                this.route.params.letter
            );
        },
        isCreditor() {
            return this.lodash.includes(
                [
                    this.INQUIRY_REMOVAL_LETTER_3,
                    this.INQUIRY_REMOVAL_LETTER_4,
                    this.CREDITOR_LATE_PAYMENT_1,
                    this.CREDITOR_LATE_PAYMENT_2
                ],
                this.route.params.letter
            );
        },
        isBureau() {
            return this.lodash.includes(
                [
                    this.REQUEST_FOR_VERIFICATION_ROUND_1,
                    this.REQUEST_FOR_VERIFICATION_ROUND_2,
                    this.REQUEST_FOR_VERIFICATION_ROUND_3,
                    this.REQUEST_FOR_VERIFICATION_ROUND_4,
                ],
                this.route.params.letter
            );
        },
        isDataFurnisher() {
            return this.lodash.includes(
                [
                    this.REQUEST_FOR_DISCLOSURE_ATTACK,
                    this.REQUEST_AN_INVESTIGATION_ATTACK,
                    this.CREDITORS_INQUIRY_METRO_2_LETTER_1,
                    this.CREDITORS_LATE_PAYMENT_METRO_2_LETTER_1
                ],
                this.route.params.letter
            );
        },
        isOthers() {
            return this.lodash.includes(
                [
                    this.CREDIT_BUREAUS_REPOSSESSION_LETTER_1,
                ],
                this.route.params.letter
            );
        }
    },
    getters: {
        getSlug: (state) => {
            return (id) => {
                const letter = _.find(state.letters, function (letter) {
                    if (letter.id == id) {
                        return letter;
                    }
                });
                return (letter && letter.slug) ? letter.slug : '';
            }
        },
        getId: (state) => {
            return (slug) => {
                const letter = _.find(state.letters, function (letter) {
                    if (letter.slug == slug) {
                        return letter;
                    }
                });
                return (letter && letter.id) ? letter.id : '';
            }
        },
    },
})
